module.exports = __webpack_public_path__ + "static/media/donasi3.e6f96ca2.jpg";